module.exports = __webpack_public_path__ + "static/media/covi_org_rou.5d85ddf1.png";